/**
 * Route for `igaming-hybrid`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingHybridPage } from "../features/igaming-hybrid/IgamingHybridPage";

export const igamingHybridRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-hybrid",
	component: IgamingHybridPage,
});

export default igamingHybridRoute;
